export default __webpack_public_path__ + "static/media/fourteen.444a785b.jpeg";